<div (mouseenter)="onMouseOver()" (mouseleave)="onMouseOut()">
    <div class="additional-record">
        <div [class.not-selected]="isHidden">
            <!-- TT 839 -->
             <ng-container *ngIf="isTrackRoller && ARDetails?.length > 0">
             <!-- <ng-container *ngIf="ARDetails?.length > 0">  -->
                <table>
                    <thead style="font-weight: bold;">
                        <tr>
                            <td>Title</td>
                            <td>Left</td>
                            <td>Right</td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let AR of ARDetails">
                            <tr *ngIf="AR.Tool == 'YES or NO'">
                                <td>{{AR.Title}}</td>
                                <td>{{parseYesNo(AR.ReadingL)}}</td>
                                <td>{{parseYesNo(AR.ReadingR)}}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>

                <table>
                    <thead style="font-weight: bold;">
                        <tr>
                            <td>Title</td>
                            <td>Left</td>
                            <td>Right</td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let AR of ARDetails">
                            <tr *ngIf="AR.Tool == 'Ruler' && AR.Tool !== 'Invalid Tool' && AR.Tool !== 'Observation'">
                                <td>{{AR.Title}}</td>
                                <td>{{AR.ReadingL}} {{UoM}} </td>
                                <td>{{AR.ReadingR}} {{UoM}} </td>
                            </tr>

                            <tr *ngIf="AR.Tool == 'Invalid Tool' || AR.Tool == 'Observation' ">
                                <td>{{AR.Title}}</td>
                                <td>{{AR.ReadingL}}</td>
                                <td>{{AR.ReadingR}}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>

                <ng-container *ngFor="let AR of ARDetails">
                    <ng-container *ngIf="AR.Tool == 'Observation'">
                        <b>{{AR.Title}} - Left</b>
                        <div class="section-content">
                            <edit-data [canEdit]="false" [value]="AR.ReadingL" [dataType]="'textarea'" [vertResizeOnly]="true"></edit-data>
                        </div>

                        <b>{{AR.Title}} - Right</b>
                        <div class="section-content">
                            <edit-data [canEdit]="false" [value]="AR.ReadingR" [dataType]="'textarea'" [vertResizeOnly]="true"></edit-data>
                        </div>                       
                    </ng-container>
                </ng-container>
            </ng-container>
            
            <ng-container *ngIf="!isTrackRoller && ARDetails?.length > 0">
                <table>
                    <thead>
                        <tr>
                            <td>Title</td>
                            <td>Left</td>
                            <td>Right</td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let AR of ARDetails">
                            <tr *ngIf="AR.Tool == 'YES or NO'">
                                <td>{{AR.Title}}</td>
                                <td>{{parseYesNo(AR.ReadingL)}}</td>
                                <td>{{parseYesNo(AR.ReadingR)}}</td>
                            </tr>
                            <tr *ngIf="AR.Tool != 'YES or NO' && AR.Tool != 'Invalid Tool' && AR.Tool != 'Observation'">
                                <td>{{AR.Title}}</td>
                                <td>{{AR.ReadingL}} {{UoM}}</td>
                                <td>{{AR.ReadingR}} {{UoM}}</td>
                            </tr>

                            <tr *ngIf="AR.Tool == 'Invalid Tool' || AR.Tool == 'Observation' ">
                                <td>{{AR.Title}}</td>
                                <td>{{AR.ReadingL}}</td>
                                <td>{{AR.ReadingR}} </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </ng-container>

        </div>

        <div class="show-hide-toggle" [class.button_selected]="isHidden" (click)="toggleShowOrHide()" *ngIf="displayToggleButton" matTooltip="Toggle Show or Hide">
            <i class="material-icons show-hide-toggle__icon">not_interested</i>
        </div>
    </div>
</div>
